import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { Context } from "../../context";
import classes from "./Contact.module.css";
import { FaPlay } from "react-icons/fa";

const Contact = () => {
  const { debug, linkedin, github, lang } = useContext(Context);
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptcha = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
    if (recaptcha.current) {
      const captchaValue = recaptcha.current.getValue();
      if (captchaValue) {
        // console.log("Captcha Value:", captchaValue);
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
      subject: "Email da davidebalice.dev",
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!recaptchaToken) {
      console.error("reCAPTCHA verification failed.");
      return;
    }

    const captchaValue = recaptcha.current.getValue();
    if (!captchaValue) {
      alert("Please verify the reCAPTCHA!");
    } else {
      const res = await fetch(`${process.env.REACT_APP_EMAIL_API}/verify`, {
        method: "POST",
        body: JSON.stringify({ captchaValue }),
        headers: {
          "content-type": "application/json",
        },
      });
      const data = await res.json();
      if (data.success) {

        try {
          const response = await fetch(
            `${process.env.REACT_APP_EMAIL_API}/send`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            }
          );
          const data = await response.json();
          console.log(data);

          setFormData({
            name: "",
            email: "",
            message: "",
            subject: "Email da davidebalice.dev",
          });

          setShowMessage(true);
          setMessage(data.message);
        } catch (error) {
          console.error(error);
        }
      } else {
        alert("reCAPTCHA validation failed!");
      }
    }
  };

  const handleCloseMessage = () => {
    setShowMessage(false);
  };

  return (
    <section id="contact" className={classes.Section}>
      <div className={classes.matrixOverlay}></div>
      <Modal show={showMessage} onHide={handleCloseMessage}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMessage}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>

      <div className={classes.container}>
        <div className={classes.editorWindow}>
          {/* Title Bar */}
          <div className={classes.titleBar}>
            <div className={classes.dots}>
              <div className={`${classes.dot} ${classes.dotRed}`}></div>
              <div className={`${classes.dot} ${classes.dotYellow}`}></div>
              <div className={`${classes.dot} ${classes.dotGreen}`}></div>
            </div>
            <div className={classes.tab}>
              <span className={classes.tabIcon}>JS</span> Contact.js
            </div>
          </div>

          {/* Editor Body */}
          <div className={classes.editorBody}>
            {/* Line Numbers */}
            <div className={classes.lineNumbers}>
              <div>1</div>
              <div>2</div>
              <div>3</div>
              <div>4</div>
              <div>5</div>
              <div>6</div>
              <div>7</div>
              <div>8</div>
              <div>9</div>
              <div>10</div>
              <div>11</div>
              <div>12</div>
              <div>13</div>
              <div>14</div>
              <div>15</div>
              <div>16</div>
              <div>17</div>
              <div>18</div>
              <div>19</div>
              <div>20</div>
              <div>21</div>
            </div>

            {/* Code Content / Form */}
            <div className={classes.codeContent}>

              {/* Comment Block / Contact Info */}
              <div className={classes.infoCommentBlock}>
                <span className={classes.comment}>/**</span>
                <span className={classes.comment}> * {lang === "it" ? "Contattami per info o collaborazioni" : "Contact me for info or collabs"} </span>
                <span className={classes.comment}> * Email: davide.balice@gmail.com</span>
                <span className={classes.comment}> */</span>
                <div className={classes.socialIcons}>
                  <a href={linkedin} target="_blank" rel="noreferrer" className={classes.socialIcon}>
                    <FontAwesomeIcon icon={faLinkedin} size="lg" />
                  </a>
                  <a href={github} target="_blank" rel="noreferrer" className={classes.socialIcon}>
                    <FontAwesomeIcon icon={faGithub} size="lg" />
                  </a>
                </div>
              </div>

              <form onSubmit={handleSubmit} id="contact-form">

                {/* const contactMessage = { */}
                <div className={classes.codeLine}>
                  <span className={classes.keyword}>const</span>
                  <span className={classes.variable}>&nbsp;contactMessage</span>
                  <span className={classes.operator}>&nbsp;=</span>
                  <span className={classes.paren}>&nbsp;{'{'}</span>
                </div>

                {/* name: "..." */}
                <div className={classes.codeLine}>
                  <span className={classes.objKey}>&nbsp;&nbsp;name</span>:
                  <div className={classes.inputWrapper}>
                    <span className={classes.string}>"</span>
                    <input
                      name="name"
                      type="text"
                      className={classes.contactInput}
                      required
                      placeholder="Your Name"
                      onChange={handleInputChange}
                      value={formData.name}
                      autoComplete="off"
                    />
                    <span className={classes.string}>",</span>
                  </div>
                </div>

                {/* email: "..." */}
                <div className={classes.codeLine}>
                  <span className={classes.objKey}>&nbsp;&nbsp;email</span>:
                  <div className={classes.inputWrapper}>
                    <span className={classes.string}>"</span>
                    <input
                      name="email"
                      type="email"
                      className={classes.contactInput}
                      required
                      placeholder="your.email@example.com"
                      onChange={handleInputChange}
                      value={formData.email}
                      autoComplete="off"
                    />
                    <span className={classes.string}>",</span>
                  </div>
                </div>

                {/* message: `...` */}
                <div className={classes.codeLine} style={{ alignItems: 'flex-start' }}>
                  <span className={classes.objKey}>&nbsp;&nbsp;message</span>:
                  <span className={classes.string}>&nbsp;`</span>
                  <div className={classes.textareaWrapper}>
                    <textarea
                      name="message"
                      className={classes.contactTextarea}
                      rows="4"
                      required
                      placeholder="Write your code logic here..."
                      onChange={handleInputChange}
                      value={formData.message}
                    ></textarea>
                  </div>
                  <span className={classes.string}>`,</span>
                </div>

                {/* } */}
                <div className={classes.codeLine}>
                  <span className={classes.paren}>{'}'}</span>;
                </div>

                <br />

                {/* Hidden Fields for HoneyPot logic */}
                <div style={{ display: "none" }}>
                  <input
                    type="text"
                    name="honeypot"
                    onChange={handleInputChange}
                    value={formData.honeypot || ""}
                  />
                  <input
                    type="text"
                    name="subject"
                    onChange={() => { }}
                    value={formData.subject || "Email da davidebalice.dev"}
                  />
                </div>

                {/* Submit Block */}
                <div className={classes.codeLine}>
                  <span className={classes.comment}>// Prepare payload and execute send</span>
                </div>

                <div className={classes.submitLine}>
                  <div style={{ marginRight: '20px' }}>
                    <ReCAPTCHA
                      ref={recaptcha}
                      sitekey={process.env.REACT_APP_SITE_KEY}
                      onChange={handleRecaptchaChange}
                      theme="dark"
                    />
                  </div>

                  <button
                    id="submit-btn"
                    className={classes.contactButton}
                    type="submit"
                  >
                    <FaPlay className={classes.playIcon} />
                    <span>execute(send)</span>
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
